export default __webpack_public_path__ + "static/media/promo-code-pdf-background.101d9874.png";